import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { DepositTransaction } from './deposit-transaction.model';
import { PaymentTransaction } from './payment-transaction.model';

export const DOCUMENT_PAYMENTS_SCHEMA = Object.freeze({
  TRANSACTIONS: List<PaymentTransaction>([]),
  DEPOSIT_TRANSACTIONS: List<DepositTransaction>(),
  LEGACY_AMOUNT_PAID: null,
});

const RECORD = generateSchema(DOCUMENT_PAYMENTS_SCHEMA);
const KEYS: any = generateKeys(DOCUMENT_PAYMENTS_SCHEMA);

export class DocumentPayments extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.TRANSACTIONS,
        value: props.get(KEYS.TRANSACTIONS)
          ? this.transactions.map((params) => new PaymentTransaction(params))
          : List<PaymentTransaction>([]),
      },
      {
        key: KEYS.DEPOSIT_TRANSACTIONS,
        value: props.get(KEYS.DEPOSIT_TRANSACTIONS)
          ? this.depositTransactions.map(
              (params) => new DepositTransaction(params)
            )
          : List<DepositTransaction>(),
      },
    ]);

    return selfModel as DocumentPayments;
  }

  get transactions(): List<PaymentTransaction> {
    return this.get(KEYS.TRANSACTIONS);
  }

  get depositTransactions(): List<DepositTransaction> {
    return this.get(KEYS.DEPOSIT_TRANSACTIONS);
  }
}
